/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wizard_Step_AnalyseInputs */

const en_wizard_step_analyse = /** @type {(inputs: Wizard_Step_AnalyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse codebase`)
};

const id_wizard_step_analyse = /** @type {(inputs: Wizard_Step_AnalyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis codebase`)
};

/**
* | output |
* | --- |
* | "Analyse codebase" |
*
* @param {Wizard_Step_AnalyseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const wizard_step_analyse = /** @type {((inputs?: Wizard_Step_AnalyseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wizard_Step_AnalyseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_wizard_step_analyse(inputs)
	return en_wizard_step_analyse(inputs)
});